import { getAPIPath, requestGooseAPI } from '../shared/request'
import {
  APILocationUserProfileClientDtoResponse,
  LocationUserProfileClientDto,
  LocationUserProfileCreateInput,
  LocationUserProfileUpdateInput,
} from '../types/api'
import { CLIENT_LOCATION_USERPROFILE_ID_PATH, CLIENT_LOCATION_USERPROFILE_PATH } from '../types/constants'

export interface TClientLocationUserProfileService {
  list: (locationName: string, includes?: string[]) => Promise<APILocationUserProfileClientDtoResponse>
  get: (locationName: string, lupId: string, includes?: string[]) => Promise<LocationUserProfileClientDto>
  put: (
    locationName: string,
    lupId: string,
    payload: LocationUserProfileUpdateInput,
    includes?: string[]
  ) => Promise<LocationUserProfileClientDto>
  post: (
    locationName: string,
    payload: LocationUserProfileCreateInput,
    includes?: string[]
  ) => Promise<LocationUserProfileClientDto>
}

export const ClientLocationUserProfileService: TClientLocationUserProfileService = {
  list: (locationName: string, includes?: string[]) =>
    requestGooseAPI<APILocationUserProfileClientDtoResponse>({
      url: getAPIPath(CLIENT_LOCATION_USERPROFILE_PATH, { locationId: locationName }),
      method: 'GET',
      params: {
        includes,
      },
    }),

  get: (locationName: string, lupId: string, includes?: string[]) => {
    return requestGooseAPI<LocationUserProfileClientDto>({
      url: getAPIPath(CLIENT_LOCATION_USERPROFILE_ID_PATH, { locationId: locationName, id: lupId }),
      method: 'GET',
      params: {
        includes,
      },
    })
  },

  put: (locationName: string, lupId: string, payload: LocationUserProfileUpdateInput, includes?: string[]) =>
    requestGooseAPI<LocationUserProfileClientDto>({
      url: getAPIPath(CLIENT_LOCATION_USERPROFILE_ID_PATH, { locationId: locationName, id: lupId }),
      method: 'PUT',
      params: {
        includes,
      },
      data: payload,
    }),

  post: (locationName: string, payload: LocationUserProfileCreateInput, includes?: string[]) =>
    requestGooseAPI<LocationUserProfileClientDto>({
      url: getAPIPath(CLIENT_LOCATION_USERPROFILE_PATH, { locationId: locationName }),
      method: 'POST',
      params: {
        includes,
      },
      data: payload,
    }),
}
